"use client"

import type React from "react"

interface PhoneFormProps {
  phone: string
  onChange: (phone: string) => void
}

const PhoneForm: React.FC<PhoneFormProps> = ({ phone, onChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="phone-input">Phone Number:</label>
      <input
        id="phone-input"
        type="tel"
        value={phone}
        onChange={(e) => onChange(e.target.value)}
        placeholder="+1234567890"
        className="text-input"
      />
    </div>
  )
}

export default PhoneForm
